/**
 * Sourced from Dashboard, modified for Shop.
 * https://github.com/squareup/dashboard/blob/49a226ece70f193b59011027ec6388f371f7f7b9/frontend/dashboard/app/helpers/user-journey/user-journey-converter.js
 */

import { UserJourneyOutcome } from 'constants/user_journeys';

// Define a JavaScript object to hold the conversion functions
export const UserJourneyResultConverter = {
  /**
   *
   * @param {UserJourneyResult} userJourneyResult
   * @returns {object}
   */
  convertToCdpEventProperties(userJourneyResult) {
    if (
      !userJourneyResult ||
      !userJourneyResult.userJourneyName ||
      !userJourneyResult.createdAt ||
      !userJourneyResult.durationRealTimeMs
    ) {
      throw new Error('Invalid UserJourney data');
    }

    return {
      ...userJourneyResult,
      /** @type {TUserJourneyOutcome} */
      outcome: userJourneyResult.outcome ?? UserJourneyOutcome.TERMINATED,
      /** @type {Array<TFrustrationSignal>} */
      frustrationSignals: [...(userJourneyResult.frustrationSignals ?? [])],
      /** @type {Array<TFrictionSignal>} */
      frictionSignals: [...(userJourneyResult.frictionSignals ?? [])],
      /** @type {Array<string>} */
      tags: [...(userJourneyResult.tags ?? [])],
    };
  },
};
